// Module
var code = `<a href="{{ employerInsightLinkCtrl.getInsightLinkUrl() }}" target="_blank"> {{ 'INSIGHT' | translate }} </a>`;
// Exports
export default code;